define('AwaLabs.CustomDisplayStock', [
    'Profile.Model',
    'CustomDisplayStock.Facets.ItemCell.View'
], function AwaLabsCustomDisplayStock(
    ProfileModel
) {
    'use strict';
    return {
        mountToApp: function mountToApp(application) {
            var layout = application.getComponent('Layout');
            layout.addToViewContextDefinition('ProductDetails.Full.View', 'displaystock', 'boolean', function fn(context) {
                var isLoggedIn = ProfileModel.getInstance().get('isLoggedIn') === 'T';
                var model = context.model;
                return model.item.custitem_show_ability_stock && isLoggedIn;
            });
        }
    };
});
